(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Qsched_typeDialogController', Qsched_typeDialogController);

    Qsched_typeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Qsched_type'];

    function Qsched_typeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Qsched_type) {
        var vm = this;

        vm.qsched_type = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.qsched_type.id !== null) {
                Qsched_type.update(vm.qsched_type, onSaveSuccess, onSaveError);
            } else {
                Qsched_type.save(vm.qsched_type, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('doctorclubboApp:qsched_typeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
